import { GreenLightLogo } from "./GreenLightLogo";

const Navbar = () => {
  return (
    <header className="sticky top-0 left-0 right-0 z-50 bg-[hsl(220_14%_96%/0.8)] backdrop-blur-md">
      <div className="mx-auto max-w-7xl flex items-center px-4 lg:px-6 py-4">
        <a
          href="https://getgreenlight.net/"
          className="shrink-0 flex items-center self-center"
          aria-label="GreenLight home"
        >
          <span className="md:hidden flex items-center">
            <GreenLightLogo width={150} animate={true} />
          </span>
          <span className="hidden md:flex items-center">
            <GreenLightLogo width={210} animate={true} />
          </span>
        </a>
      </div>
    </header>
  );
};

Navbar.displayName = "Navbar";

export default Navbar;
